/* @flow */

import * as types from 'src/shared/app/notification/action/appNotificationActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
 |------------------------------------------------------------------------------
 | Initial State
 |------------------------------------------------------------------------------
 */

const initialState = {
  braindateCount: 0,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const setBraindateCount = (state: Object, { value }: Object): Object => ({
  ...state,
  braindateCount: value,
});

const resetBraindateCount = (state: Object): Object => ({
  ...state,
  braindateCount: 0,
});

/*
 |------------------------------------------------------------------------------
 | Reducer
 |------------------------------------------------------------------------------
 */

export default createReducer(initialState, {
  [types.SET_BRAINDATE_NOTIFICATION_COUNT]: setBraindateCount,
  [types.RESET_BRAINDATE_NOTIFICATION_COUNT]: resetBraindateCount,
});
